import { createReducer } from 'typesafe-actions'

import { ActionTypes, IAccount, IAddUBO, IUserAccount } from '../types'
import { addUBO, createAccount, createUserAccount, selectAccountType } from '../actions'

export type FormStepperState = {
  accountType: string
  account: IAccount
  ubo: IAddUBO[]
  userAccount: IUserAccount
}

export const initialState: FormStepperState = {
  accountType: 'company',
  account: {
    firstName: '',
    lastName: '',
    companyName: '',
    companyEmail: '',
    role: '',
    password: '',
    confirmPassword: '',
  },
  ubo: [
    // {
    //   firstName: '',
    //   lastName: '',
    //   companyEmail: '',
    //   executingTrades: false,
    // },
  ],
  userAccount: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  },
}

export const formStepper = createReducer<FormStepperState, ActionTypes>(initialState)
  .handleAction(selectAccountType, (state, { payload }) => ({ ...state, accountType: payload }))
  .handleAction(createAccount, (state, { payload }) => ({ ...state, account: payload }))
  .handleAction(addUBO, (state, { payload }) => ({ ...state, ubo: [...state.ubo, payload] }))
  .handleAction(createUserAccount, (state, { payload }) => ({ ...state, userAccount: payload }))
